function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgUserPortal = function SvgUserPortal(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Entity Management",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "2s6wpgsyra"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2440",
    style: {
      fill: "#838383"
    },
    d: "M0 0h16v14.937H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4400"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4399",
    style: {
      clipPath: "url(#2s6wpgsyra)"
    },
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 964",
    d: "M0 10.749V1.187a.273.273 0 0 0 .023-.04A1.4 1.4 0 0 1 1.5 0h6.03v1.426a.47.47 0 1 0 .937 0V0H14.59A1.392 1.392 0 0 1 16 1.408v9.123a1.394 1.394 0 0 1-1.409 1.4H1.408a1.387 1.387 0 0 1-1.04-.458A1.712 1.712 0 0 1 0 10.749m11.254-7.5a2.719 2.719 0 1 0 2.715 2.731 2.732 2.732 0 0 0-2.715-2.731M4.969 7.995V4.999a.468.468 0 0 0-.638-.464.487.487 0 0 0-.3.485V7.991H2.969V3.559a.755.755 0 0 0-.082-.341.433.433 0 0 0-.512-.194.474.474 0 0 0-.341.5v4.891a.481.481 0 0 0 .526.523h3.888a.482.482 0 0 0 .521-.529V6.534a.473.473 0 1 0-.938 0v1.465z",
    style: {
      fill: "#838383"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 965",
    d: "m5.6 13.987.186-1.1h4.426l.189 1.114h.58a.468.468 0 1 1 0 .935H5.017a.468.468 0 1 1 0-.936h.533a.411.411 0 0 0 .051-.012",
    style: {
      fill: "#838383"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 966",
    d: "M9.715 6.861a1.774 1.774 0 0 1 1.065-2.6v.775a2.109 2.109 0 0 1-.029.74c-.085.209-.324.355-.5.529l-.541.558",
    style: {
      fill: "#838383"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 967",
    d: "M10.372 7.511c.347-.348.684-.687 1.023-1.024a.169.169 0 0 1 .105-.047h1.452a1.761 1.761 0 0 1-2.582 1.073",
    style: {
      fill: "#838383"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 968",
    d: "M11.729 4.248a1.822 1.822 0 0 1 1.242 1.241h-1.242z",
    style: {
      fill: "#838383"
    }
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUserPortal, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user-portal.25060e53.svg";
export { ForwardRef as ReactComponent };